<template>

  <div class="header container">
    <v-app-bar elevate-on-scroll fixed flat style="background: radial-gradient(circle, rgb(29, 41, 84) 20%, rgb(24, 34, 72) 57%, rgb(22, 32, 67) 88%);">
      <div class="header-layout container">
        <v-toolbar-title>
          <span class="header-logo"></span>
          <router-link aria-label="brainpower home" to="/">
            <v-img class="logo" src="@/assets/images/logo.svg" contain></v-img>
          </router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="mr-4 mt-5">
          <v-btn class="mb-5 text-capitalize font-weight-bold"
                 href="https://my.outbrain.com/amplify/funnel"
                 color="secondary"
                 target="_blank"
                 x-large
                 width="185"
                 height="50">
            Start a Campaign
          </v-btn>
        </div>
      </div>
    </v-app-bar>


  </div>

</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import SubscribeForm from '@/components/SubscribeForm.vue';
import {isMobile} from "@/components/utils/utils";

const VueScrollTo = require('vue-scrollto');

@Component({
        components: {
            SubscribeForm
        },
    })
    export default class HeaderComponent extends Vue {

        private clipped: boolean = false;
        private navDraw: boolean = false;
        private drawer: boolean = false;
        private dialog: boolean = false;
        private successSubmit: boolean = false;

        private menu: any = [
          {
                "label": "Popular Categories",
                "route": "/",
                "hash": "popular-categories"
            }, {
                "label": "Consumer Interests",
                "route": "/",
                "hash": "consumer-interests"
            }, {
                "label": "Ad Content",
                "route": "/",
                "hash": "ad-content"
            }, {
                "label": "Performance By Device",
                "route": "/",
                "hash": "performance-by-device"
            }
        ];

        mounted() {
        }

        onSubmit(e: any) {
            this.successSubmit = true;
            setTimeout(() => {
                this.dialog = false;
            }, 5000);
        }

        onClose() {
            this.dialog = false;
        }

        get routeName() {
            return this.$route.name;

        }

        isMobile():boolean{
            return isMobile();
        }

        navAndScroll(routeName: string, elementId: string){
          this.$router.push(routeName, () => { setTimeout( () => {VueScrollTo.scrollTo(elementId)}, 100 )})
        }

    }

</script>

<style lang="scss">
  .header {
    height: 54px;
    padding: 0;
    max-width: 1200px;

    .header-layout {
      max-width: 1200px;
      width: 100%;
      display: flex;
      align-items: center;
    }

    /*.v-toolbar__content {*/
    /*  padding: 0;*/
    /*  align-items: center;*/
    /*  justify-content: center;*/
    /*}*/

    .v-btn {
      letter-spacing: normal;
    }

    .v-btn__content {
      height: 16px;
      width: 128px;
      color: #151E41;
      font-size: 16px;
      line-height: 17px;
      text-transform: none !important;
    }

    .logo {
      background-position: center center;
      background-repeat: no-repeat;
      display: inline-block;
      /* margin-left: 15px; */
      vertical-align: middle;
      width: 150px;
    }


  }
  .sticky-header{
    position: sticky;
    top: 0;
    z-index: 999;
    background: white;
  }

  .thank-you-for-subscr {
    color: #0E2241;
    font-size: 36px;
    font-weight: bold;
    line-height: 36px;
    text-align: center;
  }

  .youre-all-set {
    color: #0E2241;
    font-size: 18px;
    line-height: 29px;
    text-align: center;
    padding: 20px;
    padding-bottom: 40px;
  }

  .closed_caption {
    position: absolute;
    right: 0;
    padding: 8px;
    transition: all ease-in-out 300ms;

    &:hover {
      transform: rotate(-180deg);

    }
  }

  .form-card {
      margin-top: 1rem;
  }

  .events-calendar-links a{
    font-size: 16px !important;
    color:white !important;
    text-decoration: none;
    vertical-align:middle;
  }

</style>
